import { HallWithFlag } from '../domain/schemas';
import { OptionWithFlag } from '../domain/schemas';

/**
 * 選択されたホールコードの配列と、HallWithFlag[]を照合し、
 * 選択されているホールコードに対応するhallsのisFTがtrueのものが1つでもあるかを判定する
 * @param hallCodes 選択されているホールコードの配列
 * @param halls HallWithFlag[]の配列
 * @returns isFTがtrueのホールが1つでもある場合true、それ以外false
 */
export const hasAIFlagHall = (
  hallCodes: string[],
  halls: HallWithFlag[]
): boolean => {
  const safeHallCodes = Array.isArray(hallCodes) ? hallCodes : [];
  const safeHalls = Array.isArray(halls) ? halls : [];
  return safeHallCodes.some((hallCode) => {
    const hall = safeHalls.find((h) => h.code === hallCode);
    return hall?.isFT === true;
  });
};

/**
 * OptionWithFlag[]からisAiPredictionがtrueの項目をフィルタリングする
 * @param fields フィルタリング対象のOptionWithFlag[]の配列
 * @param hasAIFlagHall AIフラグを持つホールが選択されているかどうか
 * @returns フィルタリング後のOptionWithFlag[]の配列
 */
export const filterAiPredictionFields = (
  fields: OptionWithFlag[],
  hasAIFlagHall: boolean
): OptionWithFlag[] => {
  if (hasAIFlagHall) {
    return fields;
  }
  return fields.filter((field) => !field.isAiPrediction);
};
